import type { Edition } from "shared/lib/edition";
import { PageType } from "shared/lib/page-type";

export const pathname = "/home";

export const page = {
  route(
    query: QueryParameters<{
      edition?: Edition;
      isBot?: string;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Homepage },
    };
  },
};
